import { Place } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';

const OpenInMapsButton = ({ latitude, longitude }) => {
    const openInMaps = () => {
        const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
        window.open(url, '_blank'); // Open in a new tab
    };

    return (
        <IconButton
            onClick={openInMaps}
            color="info"
            aria-label="open in Google Maps"
            style={{
                borderRadius: '50%',
                padding: 5,
                backgroundColor: '#4285F4', // Google Maps color
            }}
        >
            <Place style={{ color: 'white' }} />
        </IconButton>
    );
};

export default OpenInMapsButton;
